export enum SimilarProvidersParam {
  STATE = 'state',
  GENDER_ID = 'gender_id',
  INSURANCE_ID = 'insurance_id',
  MODALITY_IDS = 'modality_ids',
  SPECIALTY_IDS = 'specialty_ids',
  MAX_NUMBER_OF_PROVIDERS = 'automatch_providers_min_count'
}
